module.exports = __webpack_public_path__ + "media/images/campaign_sp-904b392bb14a10a418fc1fde2f1b0143.png";